import amapi from '@/api/amapi'

const state = {
  // dirs
  home: '',
  parent: '',
  current: '/',
  children: []
}

const getters = {
  home: state => state.home,
  parent: state => state.parent,
  current: state => state.current,
  children: state => state.children
}

const mutations = {
  SET_HOME (state, home) {
    state.home = home
  },
  SET_PARENT (state, home) {
    state.parent = home
  },
  SET_CURRENT (state, home) {
    state.current = home
  },
  SET_CHILDREN (state, home) {
    state.children = home
  }
}

const actions = {
  async createProtectedUrl (store, { authname, dir, enabled = 1, _username }) {
    const data = {
      uapi_module: 'DirectoryPrivacy',
      uapi_function: 'configure_directory_protection',
      authname,
      dir,
      enabled,
      _username,
    }
    try {
      await amapi.cpanel_uapi(data)
    } catch (e) {
      throw e
    }
  },
  async getProtectedUrls ({ commit }, { dir, _username }) {
    const data = {
      uapi_module: 'DirectoryPrivacy',
      uapi_function: 'list_directories',
      dir,
      _username,
    }
    const response = await amapi.cpanel_uapi(data)
    commit('SET_HOME', response.data.home.path)
    commit('SET_PARENT', response.data.parent.path)
    commit('SET_CURRENT', response.data.current.path)
    commit('SET_CHILDREN', response.data.children)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
